import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M25,14H7a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V16A2,2,0,0,0,25,14ZM16,26a2,2,0,0,1-2-2,2,2,0,0,1,1-1.72V19a1,1,0,0,1,2,0v3.28A2,2,0,0,1,18,24,2,2,0,0,1,16,26Z"/><path d="M9,8v6h2V8a4,4,0,0,1,4-4h2a4,4,0,0,1,4,4v6h2V8a6,6,0,0,0-6-6H15A6,6,0,0,0,9,8Z"/>';
export var LockSVG = function LockSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
LockSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(LockSVG);